import { ArrowRight, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'motion/react';

interface CTASectionProps {
  onQuoteClick: () => void;
}

export function CTASection({ onQuoteClick }: CTASectionProps) {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.05) 35px, rgba(255,255,255,.05) 70px)`
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="text-3xl font-semibold mb-4 text-white">Ready to Transform Your Space?</h2>
          <p className="text-white/80 mb-8 max-w-2xl mx-auto">
            Get a free quote today. Fast turnaround, professional installation, and a 1-year warranty on all work.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Button
              size="lg"
              onClick={onQuoteClick}
              className="bg-white text-primary hover:bg-white/90 shadow-lg hover:shadow-xl group"
            >
              Get Your Free Quote
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              asChild
              className="!bg-white/10 border-2 border-white/40 text-white hover:!bg-white/20 hover:border-white/60 backdrop-blur-md shadow-md"
            >
              <a href="tel:6468999891">
                <Phone className="mr-2 w-4 h-4" />
                Call 646-899-9891
              </a>
            </Button>
          </div>

          <p className="text-sm text-white/60 mt-6">
            Serving all five boroughs: Manhattan • Brooklyn • Queens • Bronx • Staten Island
          </p>
        </motion.div>
      </div>
    </section>
  );
}
